__turbopack_context__.v({
  "badges": "comboMeta-module-scss-module__8q2nlW__badges",
  "metadata": "comboMeta-module-scss-module__8q2nlW__metadata",
  "salt": "comboMeta-module-scss-module__8q2nlW__salt",
  "saltExplanation": "comboMeta-module-scss-module__8q2nlW__saltExplanation",
  "saltNumber": "comboMeta-module-scss-module__8q2nlW__saltNumber",
  "saltScale": "comboMeta-module-scss-module__8q2nlW__saltScale",
  "saltScore": "comboMeta-module-scss-module__8q2nlW__saltScore",
  "saltTier": "comboMeta-module-scss-module__8q2nlW__saltTier",
  "saltValue": "comboMeta-module-scss-module__8q2nlW__saltValue",
  "saltVote": "comboMeta-module-scss-module__8q2nlW__saltVote",
  "saltVotes": "comboMeta-module-scss-module__8q2nlW__saltVotes",
  "tile": "comboMeta-module-scss-module__8q2nlW__tile",
  "tileCaption": "comboMeta-module-scss-module__8q2nlW__tileCaption",
  "tileLabel": "comboMeta-module-scss-module__8q2nlW__tileLabel",
  "tileLink": "comboMeta-module-scss-module__8q2nlW__tileLink",
  "tileValue": "comboMeta-module-scss-module__8q2nlW__tileValue",
  "tiles": "comboMeta-module-scss-module__8q2nlW__tiles",
  "tooFewVotes": "comboMeta-module-scss-module__8q2nlW__tooFewVotes",
});
